import { render, staticRenderFns } from "./DescriptionEditor.vue?vue&type=template&id=d32ac062&scoped=true&"
import script from "./DescriptionEditor.vue?vue&type=script&lang=js&"
export * from "./DescriptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DescriptionEditor.vue?vue&type=style&index=1&id=d32ac062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32ac062",
  null
  
)

export default component.exports